import { reducerWithInitialState } from 'typescript-fsa-reducers/dist'
import * as actions from './actions'

export interface StoreState {
	readonly showBadgeModal: boolean
	readonly selectedBadgeId: number | undefined
	readonly badgeEarned: boolean
	readonly shouldBePushedToEarned: boolean
}

const INITIAL_STATE: StoreState = {
	showBadgeModal: false,
	selectedBadgeId: undefined,
	badgeEarned: false,
	shouldBePushedToEarned: false,
}

export const reducer = reducerWithInitialState(INITIAL_STATE).case(
	actions.toggleBadgeModal,
	(state, payload): StoreState => ({
		...state,
		showBadgeModal: payload.show,
		selectedBadgeId: payload.badgeId,
		badgeEarned: payload.earned,
		shouldBePushedToEarned: payload.shouldBePushedToEarned,
	}),
)
